import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Paper, Divider, List, ListItem, ListItemText, ListItemAvatar, } from '@mui/material';
import { useTokens } from '@mcn-platform/models';
import AssetImage from '../../../common/asset/AssetImage';
import capitalizeFirstLetter from '../../../common/capitalizeFirstLetter';
import PanelTitle from '../PanelTitle';
const StyledDivider = styled((props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(Divider, { ...props })))(({ theme }) => ({
    borderColor: theme.portal.site.lineColor,
    borderBottomWidth: 1,
    marginTop: theme.spacing(3.25),
    marginBottom: theme.spacing(3.25),
}));
const InstructorsContent = ({ instructors, settings: { showTitle, showInstructors, instructorsCount }, }) => {
    // console.log('ins:', showInstructors, instructors);
    const tokens = useTokens();
    return (_jsxs(Paper, { elevation: 0, sx: { display: 'flex', flexDirection: 'column' }, children: [showTitle && _jsx(PanelTitle, { title: tokens.getToken('instructorName/plural') }), showInstructors && (_jsx(List, { sx: { width: '100%', bgcolor: 'background.paper', p: 0 }, children: instructors && instructors.slice(0, instructorsCount).map((i) => (_jsxs(React.Fragment, { children: [_jsxs(ListItem, { alignItems: "flex-start", sx: {
                                m: 0, px: 1, py: 0, flexDirection: { xs: 'column', sm: 'row' },
                            }, children: [_jsx(ListItemAvatar, { sx: {
                                        pt: 0.625, mt: 0, minWidth: 100, minHeight: 100,
                                    }, children: _jsx(AssetImage, { size: "thumb400w", asset: i.profileImage, avatar: true, customStyle: { width: 100, height: 100 } }) }), _jsx(ListItemText, { primary: capitalizeFirstLetter(i.name), secondary: i.biography, className: "description", primaryTypographyProps: {
                                        sx: {
                                            color: (theme) => (theme.portal?.landingPage?.sectionSubHeaders?.font?.color),
                                            fontSize: (theme) => (theme.typography.subtitle1.fontSize),
                                            fontWeight: 'fontWeightBold',
                                        },
                                    }, secondaryTypographyProps: {
                                        sx: {
                                            color: (theme) => (theme.portal?.landingPage?.sectionText?.font?.color),
                                            typography: 'body2',
                                            pt: 0.5,
                                            fontSize: '0.90rem',
                                            whiteSpace: 'pre-line',
                                        },
                                    }, sx: { pl: { sm: 3.25, xs: '0' }, mt: { sm: 0, xs: 2 }, mb: 0 } })] }), _jsx(StyledDivider, { component: "li" })] }, i.id))) }))] }));
};
InstructorsContent.defaultProps = {
    settings: {
        showTitle: true,
        showInstructors: true,
        instructorsCount: undefined,
    },
};
InstructorsContent.meta = {
    group: 'hidden',
    name: 'Course Instructors Tab',
    description: 'Component displays the list of instructors of the course.',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title on the instructors panel',
        },
        {
            key: 'settings.showInstructors',
            name: 'Show Instructors',
            type: 'boolean',
            description: 'Show the instructors list on the Instructors panel',
        },
        {
            key: 'settings.instructorsCount',
            name: 'Instructors count',
            type: 'number',
            description: 'Display limit for instructors list.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'Instructors',
        props: {
            instructors: '@course.instructors',
            settings: {
                showTitle: true,
                showInstructors: true,
                instructorsCount: undefined, // show all
            },
        },
    },
};
export default observer(InstructorsContent);
//# sourceMappingURL=InstructorsContent.js.map